import { render, staticRenderFns } from "./WpHistoryExternalCommentsColumn.vue?vue&type=template&id=13523cd7&scoped=true&"
import script from "./WpHistoryExternalCommentsColumn.vue?vue&type=script&lang=js&"
export * from "./WpHistoryExternalCommentsColumn.vue?vue&type=script&lang=js&"
import style0 from "./WpHistoryExternalCommentsColumn.vue?vue&type=style&index=0&id=13523cd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13523cd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13523cd7')) {
      api.createRecord('13523cd7', component.options)
    } else {
      api.reload('13523cd7', component.options)
    }
    module.hot.accept("./WpHistoryExternalCommentsColumn.vue?vue&type=template&id=13523cd7&scoped=true&", function () {
      api.rerender('13523cd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/WpHistoryExternalCommentsColumn.vue"
export default component.exports